export function getChangeStats(participantIds, contacts) {

  const status = {
    added: false,
    removed: false,
    contact: null
  };

  for (let contact of contacts) {

    if (participantIds.indexOf(contact.startupUserId) === -1) {
      status.added = true;
      status.contact = contact;
      break;
    }

  }

  for (let participantId of participantIds) {

    let found = false;

    for (let contact of contacts) {

      if (contact.startupUserId === participantId) {
        found = true;
      }

    }

    if (found === false) {
      status.removed = true;
      status.contact = { startupUserId: participantId };
      break;
    }

  }

  return status;

}